



























































import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import { LeaversToolConfigurationsService } from '@/services/LeaversTool/LeaversToolConfigurationsService';
import { LeaverRulesService } from '@/services/LeaversTool/LeaverRulesService';
import {
  LeaverRuleModel,
  LeaversToolConfigurationsModel,
  LeaversToolConfigurationModel,
  RetentionPeriodType
} from '@/types';
import { config } from '@fortawesome/fontawesome-svg-core';
import LeaversToolConfigurationsVue from './LeaversToolConfigurations.vue';
import { confirmationHelper, ProcessLeaver } from '@/mixins';

export default Vue.extend({
  name: 'LeaversToolRules',
  mixins: [confirmationHelper, ProcessLeaver],
  data() {
    return {
      isLoading: false,
      pageIsLoading: false,
      configurationId: 0,
      configurations: {} as LeaversToolConfigurationsModel,
      fields: [
        {
          key: 'currentDocumentType.description',
          label: 'Current Document Type',
          sortable: true
        },
        {
          key: 'destinationDocumentType.description',
          label: 'Destination Document Type',
          sortable: true
        },
        {
          key: 'retentionPeriod',
          label: 'Retention Period',
          sortable: true
        },
        {
          key: 'retentionPeriodType',
          formatter: (value: any) => {
            return RetentionPeriodType[value];
          },
          label: 'Retention Type',
          sortable: true
        },
        {
          key: 'reference.referenceDescription',
          label: 'Reference',
          sortable: true
        },
        {
          key: 'referenceValue',
          label: 'Reference Value',
          sortable: true
        },
        {
          key: 'calculateFromReference.referenceDescription',
          label: 'Calculate From Reference',
          sortable: true
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ]
    };
  },
  methods: {
    async getConfigurationsAsync(this: any) {
      this.isLoading = true;
      await LeaversToolConfigurationsService.getAllAsync().then((result) => {
        if (result.configurationExists) {
          this.configurationId = result.configurations[0].id;
        }
        this.configurations = result;
        this.isLoading = false;
      });
    },
    async deleteRuleAsync(this: any, ruleId: number) {
      await this.hasDeleteConfirmedAsync(this.$bvModal, 'Are you sure you want to delete this rule?').then(
        async (result: boolean) => {
          if (result) {
            await LeaverRulesService.deleteAsync(ruleId);
            await this.getConfigurationsAsync();
          }
        }
      );
    }
  },
  computed: {
    selectedConfiguration(this: any): LeaversToolConfigurationModel {
      return this.configurations.configurations.find(
        (x: LeaversToolConfigurationModel) => x.id === this.configurationId
      );
    },
    configurationsDropdownOptions(this: any) {
      return this.configurations.configurationExists
        ? this.configurations.configurations.map((configuration: LeaversToolConfigurationModel) => ({
            id: configuration.id,
            description: this.getLeaverDescription(configuration.currentCabinet, configuration.destinationCabinet)
          }))
        : [];
    },
    configurationRules(this: any) {
      return this.selectedConfiguration ? this.selectedConfiguration.rules : [];
    }
  },
  async mounted() {
    this.pageIsLoading = true;
    await this.getConfigurationsAsync();
    this.pageIsLoading = false;
  },
  components: {
    MStoreTable,
    MStoreFormSelect,
    LoadingSpinner
  }
});
